package er.prateek.crossly.share

/**
 * A riddle set a friend can be challenged on: the level plus the seed its questions were generated
 * from, so both players face the identical questions. Travels through the share link as a
 * `puzzleId` (`rd:<levelId>:<seed>`), which keeps the link format and its older decoders unchanged.
 */
data class RiddleChallengeRef(val levelId: String, val seed: Long) {
    val puzzleId: String get() = "$PREFIX$levelId:$seed"

    companion object {
        const val PREFIX = "rd:"

        fun parse(puzzleId: String): RiddleChallengeRef? {
            if (!puzzleId.startsWith(PREFIX)) return null
            val parts = puzzleId.removePrefix(PREFIX).split(":")
            if (parts.size != 2 || parts[0].isBlank()) return null
            val seed = parts[1].toLongOrNull() ?: return null
            return RiddleChallengeRef(parts[0], seed)
        }
    }
}

/**
 * A riddle challenge is won only by clearing the set strictly faster *and* answering at least as
 * many questions correctly: speed alone can't win by skipping questions.
 */
fun riddleChallengeWon(
    elapsedMs: Long,
    correct: Int,
    challengerTimeMs: Long,
    challengerCorrect: Int,
): Boolean = challengeWon(elapsedMs, challengerTimeMs) && correct >= challengerCorrect
